export default {
  name: 'Text To Speech',
  selector: '.c-text-to-speech:not([data-initialized])',
};
